import { converterDataEua } from "_utils/Data";
import { TIPO_SOLICITACAO_PLACA } from "../../SolicitacaoPlaca/constants/tipoSolicitacaoPlaca";
import { IOrdenacao } from "../../SolicitacaoPlaca/interfaces/IOrdenacao";
import { IFiltrosSolicitacaoTerceiros } from "../interfaces/IFiltrosSolicitacaoTerceiros";

interface IParametrosBusca {
  filtros: IFiltrosSolicitacaoTerceiros;
  pagina: number;
  limite: number;
  ordenacao: IOrdenacao;
}

export function montarParametrosSolicitacoesTerceiros({
  filtros,
  pagina,
  limite,
  ordenacao,
}: IParametrosBusca): URLSearchParams {
  const parametros = new URLSearchParams({
    tipo: TIPO_SOLICITACAO_PLACA.TERCEIROS,
    pagina: String(pagina),
    limite: String(limite),
    ordenarPor: ordenacao.campo,
    ordem: ordenacao.direcao,
  });
  const pdi = filtros.pdi.trim();
  const [inicio, fim] = filtros.periodoSolicitacao ?? [];

  if (pdi) parametros.set("pdi", pdi);
  if (filtros.idEmpresa) parametros.set("idEmpresa", String(filtros.idEmpresa));
  filtros.idProcesso.forEach((idProcesso) =>
    parametros.append("idProcesso", idProcesso)
  );
  filtros.veiculo.forEach((veiculo) => parametros.append("veiculo", veiculo));
  if (inicio) parametros.set("dataInicio", converterDataEua(inicio) as string);
  if (fim) parametros.set("dataFim", converterDataEua(fim) as string);

  return parametros;
}
